<template>
	<div class="pt-57 box-s mb-13">
    <div class="bg_f ps_top">
      <navList :navList="navList" @getItem="getItem"></navList>
    </div>
    <div class="mlr-16 list_every">
			<van-list
			v-model="loading"
			:finished="finished"
			:finished-text="finishedtext"
			@load="initListData"
		>
			<List :list="list"></List>
		</van-list>
      
    </div>
    <loading :loadFlag="loadFlag"></loading>
		<noData v-if="show"></noData>
	</div>
</template>
<script>
	import noData from "@/components/noData"
	import loading from "@/components/loading"
  import List from '@/components/List.vue'
  import navList from '@/components/navList'
	import { informationList } from '@/api/api.js'
	import { getList} from "@/utils/common.js";
	export default {
		components: {
			List,
      navList,
			loading,
			noData
		},
		data() {
			return {
			  navList: JSON.parse(this.$route.query.data),
        list: [],
				loading: false,
				finished:false,
				finishedtext: '',
        page: 1,
				iid: JSON.parse(this.$route.query.data)[0].id,
				loadFlag: false,
				show: false
			};
		},
		created() {
		},
		methods: {
			initListData(){
				getList(this, informationList,  { iid: this.iid, page: this.page } )	
			},
			getItem(obj){
				this.page = 1
				this.iid = obj.item.id
				this.list = []
				this.finishedtext = ''
				this.finished = false
				this.show = false
        this.initListData()
			}
		}
	}
</script>
<style lang="less" scoped>
/deep/.van-list__finished-text{
  line-height: 0.373333rem !important;
	padding-top: 15px;
}
/deep/.van-list__loading {
	display: none;
  // line-height: 0.373333rem !important;
	// padding-top: 15px;
}
</style>
